$(function () {
    if ($(".page-dcf").length > 0) {
        //if on the right page
        window.app.daycare = (function ($, w) {
            var self = this;
            self.map = null;
            

            return {
                initMap: function map(lat, long, name) {
                    self.map = new Microsoft.Maps.Map('.map', {
                        center: new Microsoft.Maps.Location(lat, long)
                    });

                    var center = self.map.getCenter();

                    var pin = new Microsoft.Maps.Pushpin(center, {
                        title: name,
                        text: ' '
                    });

                    //Add the pushpin to the map
                    self.map.entities.push(pin);
                }
            };
        })(jQuery, window);
    }
});